

























import { Component, Vue, Prop } from 'vue-property-decorator';
import ColumnContent from './column-content';

interface ColumnConfig {
  type?: string,
  label: string,
  key: string,
  align?: string,
  width?: string,
  minWidth?: string,
  headerAlign?: string,
  className?: string,
  labelClassName?: string,
  showOverflowTooltip?: boolean,
  resizable?: boolean,
  sortable?: boolean,
  sortOrders?: any,
  sortMethod?: Function,
  filters?: any,
  filterMultiple?: boolean,
  filterMethod?: Function,
  fixed?: string | boolean,
  inputType?: string,
  imgWidth?: string | number,
  imgHeight?: string | number,
  tagType?: string,
  radiusable?: boolean,
  isInput?: boolean,
  list?: any
}

@Component({
  components: { ColumnContent }
})
export default class MuTableColumn extends Vue {
  @Prop({ default: () => [] }) private config: ColumnConfig;
  defaultConfig: any = {
    type: 'text',
    align: 'left',
    resizable: true,
    sortOrders: ['ascending', 'descending', null]
  };

  mounted() {
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) this.config[key] = this.defaultConfig[key];
    });
  }

}
